var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"myText",staticClass:"text"},[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")]),_vm._v(" "),_c('a',{ref:"showMoreBtn",staticClass:"jump-page-link",staticStyle:{"display":"none"}},[_vm._v("查看更多")])])}
var staticRenderFns = []

export { render, staticRenderFns }